var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'base-tag-container',
    {'active': _vm.active},
    {'disabled': _vm.disabled},
  ],on:{"click":_vm.onClick}},[_c('router-link',{staticClass:"dynamic-underline",attrs:{"to":_vm.linkParams}},[_c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(_vm.item.name))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }